import {
  SPINNER_SIZE_PX,
  SPINNER_THICKNESS,
} from 'ui/spinner/spinner.constants';
import { StyledSpinner } from 'ui/spinner/spinner.styles';
import type { SpinnerProps } from 'ui/spinner/spinner.types';

const Spinner = ({
  size = 'small',
  label = 'Loading',
  ...rest
}: SpinnerProps) => (
  <StyledSpinner
    variant="indeterminate"
    disableShrink
    enableTrackSlot
    color="inherit"
    size={SPINNER_SIZE_PX[size]}
    thickness={SPINNER_THICKNESS}
    aria-label={label}
    {...rest}
  />
);

export default Spinner;
